import { Component, inject, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { GenericFormUICDTO, GenericFormUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/FormUIC/form-uic.interface';
import { GenericFormUICService } from 'src/app/Common/UICServices/FormUIC/form-uic.service';
import { GenericListUICDTO, GenericListUICReadByTenantIdRequestDTO } from 'src/app/Common/UICServices/ListUIC/list-uic.interface';
import { GenericListUicService } from 'src/app/Common/UICServices/ListUIC/list-uic.service';
import { UICMasterType } from 'src/app/Common/UICServices/uic.enum';
import { UserLoginService } from 'src/app/Common/UserLoginService/userlogin.service';
import { ConfirmmodalserviceService } from '../confirm-delete-modal/confirmmodalservice.service';
import { UicFormComponent } from '../uic-form/uic-form.component';
import { InstructionsMasterCreateRequestDTO, InstructionsMasterDeleteRequestDTO, InstructionsMasterDTO, InstructionsMasterReadByMasterIdRequestDTO, InstructionsMasterUpdateRequestDTO } from './instructions.interface';
import { InstructionsService } from './instructions.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.css']
})
export class InstructionsComponent {
  @Input({ required: true }) masterType: string = '';
  @Input({ required: true }) masterId: number = 0;

  Toaster = inject(ToastrService)

  gListUICService = inject(GenericListUicService);
  gFormUICService = inject(GenericFormUICService);
  instructionData: InstructionsMasterDTO[] = []
  instructionService = inject(InstructionsService);
  User = inject(UserLoginService).User()

  route = inject(ActivatedRoute)

  @ViewChild('uicFormRef')
  UicFormComponent!: UicFormComponent;
  private confirmModal = inject(ConfirmmodalserviceService);

  imListUIC: GenericListUICDTO[] = []
  imFormUIC: GenericFormUICDTO[] = []

  instructionForm = new FormGroup({})

  ngOnInit(): void {

    this.GetTableUI();
    this.GetFormUI();



  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['masterId'] && this.masterId > 0) {
      this.getInstructions();
    }
  }

  resetForm() {
    this.UicFormComponent.ReadyUICForm();
  }


  GetTableUI() {
    let data: GenericListUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.InstructionsList,
      tenantId: this.User.companyId
    }

    this.gListUICService.GenericListUIC_ReadByTenantId(data).subscribe(res => {

      this.imListUIC = res.items




    })
  }

  GetFormUI() {
    let data: GenericFormUICReadByTenantIdRequestDTO = {
      masterType: UICMasterType.InstructionsForm,
      tenantId: this.User.companyId
    }
    this.gFormUICService.GenericFormUIC_ReadByTenantId(data).subscribe(res => {
      this.imFormUIC = res.items

    })
  }
  handleActionClick(event: { actionName: string; rowData: any; }) {
    const { actionName, rowData } = event


    if (actionName === 'Edit') {
      this.UicFormComponent.gFormGroup = this.instructionForm
      this.UicFormComponent.modalHeader = rowData ? 'Update Instruction' : 'Create Instruction';
      this.UicFormComponent.gFormUIC = [...this.imFormUIC]
      this.UicFormComponent.ReadyUICForm();

      if (rowData) {
        const patchData: any = {};

        this.imFormUIC.forEach(f => {
          let value = rowData[f.dbFeildName!];
          patchData[f.dbFeildName!] = value;
        });

        this.UicFormComponent.gFormGroup.patchValue(patchData);
      }
    }
    else if (actionName === 'Delete') {

      this.confirmModal.openDeleteModal(rowData.instructionsId!, rowData).subscribe(res => {

        if (res) {

          let data: InstructionsMasterDeleteRequestDTO = {
            instructionsId: rowData.instructionsId,
            tenantId: this.User.companyId,
            tenantBranchId: this.User.loggedInBranchId,
            actionUser: this.User.userId.toString()
          };

          this.deleteInstruction(data)
        }
      })
    }
  }

  submitForm() {

    this.UicFormComponent.gFormGroup.markAllAsTouched();

    if (this.UicFormComponent.gFormGroup.valid) {

      const formValues = this.UicFormComponent.gFormGroup.value


      if (formValues.instructionsId && formValues.instructionsId !== 0) {

        let updatedData: InstructionsMasterUpdateRequestDTO = {
          ...formValues,
          isActive: 1,
          actionUser: this.User.userId.toString()
        }
        this.updateInstruction(updatedData);
      }
      else {
        const createData: InstructionsMasterCreateRequestDTO = {

          tenantId: this.User.companyId,
          tenantBranchId: this.User.loggedInBranchId,
          masterType: this.masterType,
          masterId: this.masterId,
          remarks: formValues.remarks ?? "",
          displaySeq: formValues.displaySeq ?? 0,
          otherDetail1: formValues.otherDetail1 ?? "",
          otherDetail2: formValues.otherDetail2 ?? "",
          otherDetail3: formValues.otherDetail3 ?? "",
          otherDetail4: formValues.otherDetail4 ?? "",
          otherDetail5: formValues.otherDetail5 ?? "",
          otherDetail6: formValues.otherDetail6 ?? "",
          actionUser: this.User.userId.toString()
        };


        this.createInstruction(createData);
      }
    }


  }

  createInstruction(data: InstructionsMasterCreateRequestDTO) {
    this.instructionService.InstructionsMaster_Create(data).subscribe({
      next: (res) => {
        this.Toaster.success('Changes Saved', 'Success')

        this.getInstructions();
        this.resetUicFormSafely()
      },
      error: (err) => {
        console.error('Error creating instruction:', err);
        this.UicFormComponent.isSubmitting = false;
      }

    })
  }

  updateInstruction(data: InstructionsMasterUpdateRequestDTO) {

    this.instructionService.InstructionsMaster_Update(data).subscribe({
      next: (res) => {
        // this.UicFormComponent.modalHeader = 'Create Instruction';
        this.Toaster.success('Changes Saved', 'Success')

        this.getInstructions();
        this.resetUicFormSafely()
      },
      error: (err) => {
        console.error('Error updating instructions:', err);
        this.UicFormComponent.isSubmitting = false;
      }
    })
  }


  deleteInstruction(data: InstructionsMasterDeleteRequestDTO) {
    this.instructionService.InstructionsMaster_Delete(data).subscribe(res => {
      this.getInstructions();
    })
  }

  getInstructions() {
    let data: InstructionsMasterReadByMasterIdRequestDTO = {
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      masterType: this.masterType,
      masterId: this.masterId
    }

    this.instructionService.InstructionsMaster_ReadByMasterId(data).subscribe((res => {
      this.instructionData = res.items;
      this.instructionsForm.patchValue(res.items[0] ?? {});
      if(this.UicFormComponent){
        this.patchDisplaySeq();
      }
    }))

  }

  patchDisplaySeq() {
    if (!(this.masterType.toLowerCase() == 'quotationdetail')) {
      let displaySeq = this.instructionData.length > 0
        ? Math.max(...this.instructionData.map(item => item.displaySeq || 0)) + 1
        : 1;

      this.UicFormComponent.gFormGroup.get('displaySeq')?.patchValue(displaySeq);
    }
  }


  handleFormReady(event: boolean) {
    if (event) {
      this.patchDisplaySeq();
    }
  }




  instructionsForm = new FormGroup({
    instructionsId: new FormControl(0),
    companyId: new FormControl(0),
    branchId: new FormControl(0),
    masterType: new FormControl(''),
    masterId: new FormControl(0),
    remarks: new FormControl(''),
    displaySeq: new FormControl(0),
    otherDetail1: new FormControl(''),
    otherDetail2: new FormControl(''),
    otherDetail3: new FormControl(''),
    otherDetail4: new FormControl(''),
    otherDetail5: new FormControl(''),
    otherDetail6: new FormControl(''),
    isActive: new FormControl(1),
    actionUser: new FormControl(''),
  })


  onSubmit() {
    let formValues = this.instructionsForm.value;
    let updatedData: InstructionsMasterUpdateRequestDTO = {
      isActive: 1,
      actionUser: this.User.userId.toString(),
      instructionsId: formValues.instructionsId ?? 0,
      tenantId: this.User.companyId,
      tenantBranchId: this.User.loggedInBranchId,
      masterType: this.masterType,
      masterId: this.masterId,
      remarks: formValues.remarks ?? '',
      displaySeq: 0,
      otherDetail1: formValues.otherDetail1 ?? '',
      otherDetail2: formValues.otherDetail2 ?? '',
      otherDetail3: formValues.otherDetail3 ?? '',
      otherDetail4: formValues.otherDetail4 ?? '',
      otherDetail5: formValues.otherDetail5 ?? '',
      otherDetail6: formValues.otherDetail6 ?? ''

    }
    if (formValues.instructionsId && formValues.instructionsId !== 0) {

      this.updateInstruction(updatedData);
    } else {
      this.createInstruction(updatedData);
    }

  }

  resetUicFormSafely() {
    if (this.UicFormComponent) {
      this.UicFormComponent.ReadyUICForm();
    }
  }



}
